import { Navigate, useLocation } from "react-router-dom";
import { useDynamicContext, useIsLoggedIn } from "@dynamic-labs/sdk-react-core";

import { Paths } from "../common/constants";
import MainContainer from "../components/containers";

const PrivateRoute = ({ children }: any) => {
  const location = useLocation();

  const { sdkHasLoaded } = useDynamicContext();
  const isLoggedIn = useIsLoggedIn();

  // Wait for Dynamic session hydration
  if (!sdkHasLoaded) {
    return null; // or loader spinner
  }

  // Not authenticated → redirect to login
  if (!isLoggedIn) {
    return <Navigate to={Paths.SIGNIN} replace state={{ from: location }} />;
  }

  // Authenticated → render protected content
  return <MainContainer>{children}</MainContainer>;
};

export default PrivateRoute;
